import FormTextInput from './FormTextInput';
import { FormTextInputProps } from './type';

export type { FormTextInputProps };
export default FormTextInput;
